const DEV = import.meta.env.DEV || import.meta.env.VITE_USE_MOCKS === 'true';
const LEVEL = (import.meta.env.VITE_LOG_LEVEL ?? (DEV ? 'debug' : 'warn')) as 'debug' | 'info' | 'warn' | 'error';
const allow = (lvl: 'debug' | 'info' | 'warn' | 'error') =>
  LEVEL === 'debug' ||
  (LEVEL === 'info' && lvl !== 'debug') ||
  (LEVEL === 'warn' && (lvl === 'warn' || lvl === 'error')) ||
  (LEVEL === 'error' && lvl === 'error');

export const logger = {
  debug: (...a: any[]) => {
    if (DEV && allow('debug')) console.debug(...a);
  },
  info: (...a: any[]) => {
    if (DEV && allow('info')) console.info(...a);
  },
  warn: (...a: any[]) => {
    if (allow('warn')) console.warn(...a);
  },
  error: (...a: any[]) => {
    if (allow('error')) console.error(...a);
  },
};
